import { render } from "./TransferValueFieldContainer.vue?vue&type=template&id=39c2953b"
import script from "./TransferValueFieldContainer.vue?vue&type=script&lang=js"
export * from "./TransferValueFieldContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__